import React from "react"
import { StaticQuery, graphql, withPrefix, navigate } from "gatsby"
import BaseTerminal from "terminal-in-react"
import dayjs from 'dayjs'
import profile_pic from "./profile-pic"

const LS_L_TIME_FORMAT = 'MMM DD HH:mm'
// It would seem that in order to use a class component and get data
// one must use StaticQuery but then the data isn't available to the class.
// So the implementation here sticks it onto the class once available.
class Terminal extends React.Component {
  constructor (props) {
    super(props)
    this.state = { val: 2 }
  }
  
  ls = (args) => {
    if (args.unknownOptionMessage) {
      return args.unknownOptionMessage
    }

    let isAskingAboutParent = args._[0] === ".."

    let files
    if (!this.isPost || (this.isPost && isAskingAboutParent)) {
      files = this.posts.map( (post, i) => {
        let long_format = post.date.format(LS_L_TIME_FORMAT)
        return (
          <div className="ls-filedir" key={i}>
            {args.l && long_format} {post.slug}
          </div>
        )
      })
    } else {
      files = []
    }
    // Add "symlinks" to first and latest posts
    for (let [name, post] of Object.entries(this.symlinks)) {
      if (post) {
        let long_format = post.date.format(LS_L_TIME_FORMAT)
        let slugName = post.slug
        if (this.isPost) {
          slugName = "../" + slugName
        }
        files.unshift(
          <div className="ls-filedir" key={name}>
      {args.l && long_format} {name}{args.l && ` -> ${slugName}`}
          </div>
        )
      }
    }

    if (args.a) {
      const root = withPrefix("/")
      const currentLocation = window.location.pathname 
      const atRoot = currentLocation === root
      let long_format_dotdot
      let long_format_here
      if (atRoot) {
        long_format_dotdot = dayjs('2017-09-13T16:00:04Z').format(LS_L_TIME_FORMAT)
        long_format_here = this.siteBuildTime.format(LS_L_TIME_FORMAT)
      } else {
        long_format_dotdot = this.siteBuildTime.format(LS_L_TIME_FORMAT)
        long_format_here = this.ownPost.date.format(LS_L_TIME_FORMAT)
      }
      files.unshift(<div className="ls-filedir" key="dotdot">{args.l && long_format_dotdot} ..</div>)
      files.unshift(<div className="ls-filedir" key="dot">{args.l && long_format_here} .</div>)
    }
    
    return (
      <div className="ls-wrapper">{files}</div>
    )
  }

  cd = (args) => {
    const root = withPrefix("/")
    const currentLocation = window.location.pathname 
    const atRoot = currentLocation === root
    let newLocation = args._[0]

    // Handle no arg / root request
    if (!newLocation || newLocation === '~') {
      navigate("/")
      return
    }

    // Handle ..
    if (newLocation === "..") {
      if (atRoot) {
        window.location = "https://people.kingsds.network/"
      } else {
        navigate("/")
      }
      return
    }

    // Clean up newLocation
    if (!atRoot && newLocation.indexOf("../") === 0) {
      newLocation = newLocation.slice(3)
    }
    newLocation = newLocation.replace(/\//g,'')

    // Try to look up newLocation in symlinks
    if (this.symlinks[newLocation]) newLocation = this.symlinks[newLocation].slug

    // Try to go there
    if (this.posts.some( p => p.slug === newLocation)) {
      navigate(newLocation)
    } else {
      return `cd: no such file or directory: ${newLocation}`
    }
  }

  pwd = (arg) => {
    let wd = "/home/kcerb/"
    if (this.isPost) wd += this.ownPost.slug
    return wd
  }

  whoami = () => {
    return (
      <div>
    <div id="profile-pic">{profile_pic}</div>
<div>{String.raw`
                *   KC Erb   *

I'm a cross between a scientist (PhD in
physics) and a software engineer (hobby
turned career). That combination of skills
landed me an invitation to head up the
scientific application development efforts
here at KDS. In that role I've been getting
some pilots off the ground by translating
research projects from languages like C
and FORTRAN to Javascript.`}</div>
</div>)
  }

  getNote = () => {
    return (
      <h1 style={{textAlign: "center"}}>Old School Links</h1>
    )
  }

  // turn -a -f -c into afc or -f into f
  combineOpts = (args) => {
    let newArgs = []
    let opts = []
    args.slice(1).forEach(x => {
      x[0] === "-" ? opts.push(x.slice(1)) : newArgs.push(x)
    })
    return [opts.join(''), newArgs]
  }

  // Given a combined string of opts (see `combineOpts`) we have bad opts
  // if an opt was passed that is not allowed.
  hasBadOpts = function (combinedOpts, allowed='') {
    return combinedOpts.split('').find( o => !allowed.includes(o))
  }
  
  getSlugs = () => {
    let slugs = this.posts.map(p => p.slug)
    for (let [name, post] of Object.entries(this.symlinks)) {
      if (post) slugs.push(name)
    }
    return slugs
  }

  render () {
    let baseTerminal = <BaseTerminal
        color='#00ff00'
        backgroundColor='black'
        barColor='black'
        style={{ fontWeight: "bold", fontSize: "1em" }}
        commands={{
          ls: {
            method: this.ls,
            options: [{
              name: 'a',
              defaultValue: false,
              description: 'Include directory entries whose names begin with a dot (.).',
            },
            {
              name: 'l',
              defaultValue: false,
              description: 'List in long format.',
            }]
          },
          cd: {
            method: this.cd,
            autoComplete: this.getSlugs,
          },
          pwd: this.pwd,
          whoami: this.whoami
        }}
        descriptions={{
          ls: 'list directory contents',
          cd: "change directory",
          pwd: "print working directory",
          show: false,
          whoami: "print author's bio"
        }}
        msg={String.raw`
// ************************ //
    ____  _     ___   ____ 
   | __ )| |   / _ \ / ___|
   |  _ \| |  | | | | |  _ 
   | |_) | |__| |_| | |_| |
   |____/|_____\___/ \____|
   
// ************************ //

`}
        startState='maximised'
        getNote={this.getNote}
        /*plugins={[
          FileSystemPlugin
        ]}*/
      />

      const instance = this


      return (<StaticQuery
        query={graphql`
        {
            allMarkdownRemark(sort: {order: ASC, fields: [fields___slug]}) {
              nodes {
                fields {
                  slug
                }
                frontmatter {
                  date
                }
              }
            }
            site {
              buildTime
            }            
          }
        `}
        // 
        render={data => {
          instance.nodes = data.allMarkdownRemark.nodes
          instance.posts = this.nodes.map(node => {
            let slug = node.fields.slug.replace(/\//g,'')
            let date = dayjs(node.frontmatter.date)
            return {slug, date}
          })
          if (this.props.postSlug) {
            instance.ownPost = instance.posts.find( post => this.props.postSlug.includes(post.slug))
          }
          instance.isPost = !!instance.ownPost
          instance.siteBuildTime = dayjs(data.site.buildTime)
          // build oldest, newest, prev, next symlinks
          let sortedPosts = [...instance.posts]
          sortedPosts.sort( (a,b) => a.date.diff(b.date))
          if (instance.isPost) {
            let thisIdx = sortedPosts.indexOf(instance.ownPost)
            instance.symlinks = {
              prev: sortedPosts[thisIdx-1],
              next: sortedPosts[thisIdx+1]
            }
          } else {
            instance.symlinks = {
              first: sortedPosts[0],
              latest: sortedPosts.pop()
            }
          }
          return React.cloneElement(baseTerminal, instance.props)
        }}
      />)
  }
}
export default Terminal